import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Announcement } from 'src/app/core/models/announcement';
import { NgClass, DatePipe } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { SanitizerPipe } from '../../pipes/sanitizer.pipe';

@Component({
    selector: 'app-announcement-modal',
    templateUrl: './announcement-modal.component.html',
    styleUrls: ['./announcement-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgClass, ReactiveFormsModule, FormsModule, DatePipe, SanitizerPipe]
})
export class AnnouncementModalComponent {
  announcement!: Announcement;
  dontShowAgain = false;

  private activeModal = inject(NgbActiveModal);

  ok() {
    this.activeModal.close(this.dontShowAgain ? 'suppress' : 'ok');
  }
}
